import Calendar from "./GlobalCalendarContainer";

export default Calendar;
